// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setProviderList,
  resetProviderManagement
} from 'src/store/modules/admin/providerManagement'

const initialState = {
  providerList: []
}

export default handleActions(
  {
    [setProviderList](state, { payload: providerList }) {
      return {
        ...state,
        providerList
      }
    },

    [resetProviderManagement]() {
      return initialState
    }
  },
  initialState
)
